// import { authReset } from 'redux/actions/auth'
// import store from 'redux/store'
import axios from 'axios'
import { baseUrl } from 'repositories/restfuls/apis/api.v4.x'

let storage = null
let token = ''

const instance = axios.create({
  baseURL: `${baseUrl}/api/`,
  withCredentials: false,
})

instance.interceptors.request.use(
  (req) => {
    storage = JSON.parse(localStorage.getItem('guardexpert_logon'))

    if (storage) {
      token = storage.info.id
    }
    req.headers.authorization = token
    req.headers['Access-Control-Allow-Origin'] = '*'
    req.headers['Access-Control-Allow-Methods'] =
      'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    return req
  },
  (error) => {
    console.log('instance.interceptors.request :\n' + error)
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (res) => {
    return res
  },
  (error) => {
    console.log('instance.interceptors.response:\n', error)
    // if (!error.response) {
    //   store.dispatch(authReset())
    //   return Promise.reject(error)
    // }
    // if (error.response.status === 401) {
    //   store.dispatch(authReset())
    // }
    return Promise.reject(error)
  }
)

export default instance
